import { createFileRoute } from '@tanstack/react-router';
import { PublicSharePage } from '@/features/share-links/pages/public-share-page';

/**
 * Public: a share link (`/l/{token}`, GEDX-FE-03). No session and no app shell: the page only
 * calls the public share-link endpoints, and its code loads as its own chunk.
 */
export const Route = createFileRoute('/l/$token')({
  component: PublicShareRoute,
});

function PublicShareRoute() {
  const { token } = Route.useParams();
  return <PublicSharePage token={token} />;
}
